<h1 mat-dialog-title>{{ data.title || 'Action Could Not be Completed' }}</h1>
<div mat-dialog-content>
    <pre class="pre-wrap">
        <p *ngIf="!data.body">{{ data.message || 'The action you were trying to take could not be completed. Please close this message and try again. If you continue to experience problems, contact the support team.' }}</p>
        <div [innerHTML]="data.body" *ngIf="data.body"></div>
    </pre>
    <div class="modal-list">
        <div *ngFor="let item of data.modalList" class="list-item">
            <p>{{ item }}</p>
        </div>
    </div>
</div>
<div class="form-footer">
    <button mat-button class="primary" (click)="close()">{{ data.button || 'Close' }}</button>
</div>
